import {FormTextField} from '@ui/forms/input-field/text-field/text-field';
import {Trans} from '@ui/i18n/trans';
import {FileUploadProvider} from '@common/uploads/uploader/file-upload-provider';
import {FormSwitch} from '@ui/forms/toggle/switch';
import {useTrans} from '@ui/i18n/use-trans';
import {message} from '@ui/i18n/message';
import {FormImageSelector} from '@common/uploads/components/image-selector';
import {ImageIcon} from '@ui/icons/material/Image';
import {useAuth} from '@common/auth/use-auth';
import {FormNormalizedModelField} from '@common/ui/normalized-model/normalized-model-field';

export function CrupdatePlaylistFields() {
  const {trans} = useTrans();
  const {hasPermission} = useAuth();
  const canAssignOwner = hasPermission('playlists.assign');

  return (
    <section className="rounded-panel border bg-paper p-16 md:p-20">
      <div className="mb-16 border-b pb-12">
        <h2 className="text-base font-semibold">
          <Trans message="Playlist details" />
        </h2>
        <p className="mt-4 text-sm text-muted">
          <Trans message="Define the identity and visibility of the playlist." />
        </p>
      </div>
      <div className="grid grid-cols-1 gap-20 md:grid-cols-[180px,minmax(0,1fr)]">
        <FileUploadProvider>
          <FormImageSelector
            name="image"
            diskPrefix="playlist_media"
            variant="square"
            previewSize="w-160 h-160"
            className="mx-auto md:mx-0"
            placeholderIcon={<ImageIcon />}
            showRemoveButton
            stretchPreview
          />
        </FileUploadProvider>
        <div className="space-y-16">
          <FormTextField autoFocus name="name" label={<Trans message="Name" />} />
          <FormSwitch
            name="collaborative"
            description={<Trans message="Invite other users to add tracks." />}
          >
            <Trans message="Collaborative" />
          </FormSwitch>
          <FormSwitch
            name="public"
            description={<Trans message="Everyone can see public playlists." />}
          >
            <Trans message="Public" />
          </FormSwitch>
          {canAssignOwner && (
            <FormNormalizedModelField
              endpoint="normalized-models/user"
              name="owner_id"
              label={<Trans message="Owner" />}
              placeholder={message('Select a user...')}
              searchPlaceholder={message('Search user by name or email...')}
            />
          )}
        </div>
      </div>
      <FormTextField
        className="mt-20"
        name="description"
        label={<Trans message="Description" />}
        inputElementType="textarea"
        rows={4}
        placeholder={trans(message('Give your playlist a catchy description.'))}
      />
    </section>
  );
}
